import {Component, model} from '@angular/core';

@Component({
  selector: 'error-message',
  imports: [
  ],
  templateUrl: './error-message.component.html',
  styleUrl: './error-message.component.css'
})
export class ErrorMessage {
  toastMessage = model("");

  /**
   * Reset the error message.
   */
  closeError() {
    this.toastMessage.set("");
  }
}
